import { useTranslation } from "react-i18next";

import { useCreateProject } from "@/entities/project";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";

import ProjectForm from "./ProjectForm";

const Create = () => {
  const { t } = useTranslation();

  const mutation = useCreateProject();

  const saveButtonLabel = t("global:add");
  const initialValues = {};

  const onNavigateToProject = useNavigateToRessource(
    "/projects/{{id}}",
    (response) => response.data.data.id
  );

  return (
    <ProjectForm
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      onMutate={onNavigateToProject}
    />
  );
};
export default Create;
